module.exports = __webpack_public_path__ + "static/profile-4db57fdb616c95b6fd0602437a76694f.png";